import { render, staticRenderFns } from "./DetailEvent.vue?vue&type=template&id=1516afbc&scoped=true&"
import script from "./DetailEvent.vue?vue&type=script&lang=js&"
export * from "./DetailEvent.vue?vue&type=script&lang=js&"
import style0 from "./DetailEvent.vue?vue&type=style&index=0&id=1516afbc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516afbc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonBlob: require('/opt/build/repo/components/ButtonComponents/ButtonBlob.vue').default})
